<template>
    <div class="contact-construction">  
        <Navbar></Navbar>
        <div class="box content-area">
        <div class="columns">
            <div class="column">
                <div class="text-content">
                    <h2 class="title">Address</h2>
                        <p class="subtitle">
                            Jl. HM Idrus II No. 38A. Jatikramat<br> Bekasi <br>
                            West Java - Indonesia
                        </p><br>
                    <h2 class="title">Telephone</h2>
                        <p class="subtitle">
                            Phone :+62 21 807 06997 <br>
                            FAX : +62 21 869 05851 <br>
                        </p><br>
                    <h2 class="title">Email</h2>
                    <p class="subtitle">sar.aero@yahoo.com</p>
                </div>
            </div>
            <div class="column">
                <div class="contact-field">
                    <p class="title">Message Us</p>
                    <div class="box">
                        <p class="text-contact"><b> Name</b> </p>
                        <input class="input" type="text" placeholder=" Your Name"><br><br>
                        <p class="text-contact"><b> Email</b> </p>
                        <input class="input" type="email" placeholder=" Your Email"><br><br>
                        <p class="text-contact"><b> Message Us</b> </p>
                        <textarea class="textarea" placeholder="e.g. Hello world"></textarea><br>
                        <a class="button is-dark">Send Message</a>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
    components:{
        Navbar,
        Footer
    }
}
</script>

<style scoped>

.text-content{
    text-align: left;
    margin-left: 100px;
    margin : 20px;
}
.text-contact{
    text-align: left;
}
.contact-field{
    margin: 20px;
}

.content-area{
    margin: 50px;
    /* margin: auto; */
    background-color: rgb(233, 233, 233)
}

</style>
